import {Image} from "react-bootstrap"
import { useParams } from "react-router-dom"
import {Container,Row,Col} from "react-bootstrap"
import {socket} from "../App"
import {useEffect,useState} from "react"
import {db} from "../firebase"
import {collection,doc,getDocs} from "firebase/firestore"
import {query,where,documentId} from "firebase/firestore"
import {useNavigate} from "react-router-dom"
import {useAuthState} from "react-firebase-hooks/auth"
import {auth} from "../firebase"


import { Carousel } from "react-bootstrap"

import {EmailShareButton, FacebookShareButton} from "react-share"
import {TwitterIcon} from "react-share"
import {TelegramShareButton} from "react-share"
import {RedditShareButton} from "react-share"
import {TelegramIcon} from "react-share"
import {RedditIcon} from "react-share"


export const ImagePage = () => {
    const {id} = useParams()
    const [cartoon,setCartoon] = useState(null)
    const navigate = useNavigate()
    const [user] = useAuthState(auth)

    const cartoonsRef = collection(db,"cartoons")

    const q = query(cartoonsRef,where("id","==",id))


    const getCartoon = async () => {
      const res = await getDocs(q)
      console.log("cart",res.docs[0].data())
      setCartoon(res.docs[0].data())
    }

    useEffect(() => {
      console.log(id)
      if (!id || id === "undefined") {
        navigate("/");
      } else {
        getCartoon();
      }
    },[id])


    return (
      <Container className="mt-5" >
      <Row>
        <Col xs={12} md={8} lg={6}>
        <h1 className=" mb-4 mt-4" 
      style={{textAlign:"left",cursor:"pointer"}} 
      onClick={() => navigate("/")}>
        Photoevolve
        </h1>
        {user && <div style={{textAlign:"left",marginBottom:"15px"}}>logged in @{user?.displayName}</div>}

          <div>A cartoon by {cartoon && cartoon.creators.join(', ')}</div>
        
            <Carousel interval={null}
            indicators={false}
            slide={false}
            fade={false}
            wrap={false}>

              {cartoon && cartoon.scenes.map((scene,index) => {
                return (
                  <Carousel.Item key={index}>
                  <Image src={scene.imgUrl} fluid/>
                  <div style={{textAlign:"left"}}>{scene.text}
                  <br/>
                  <strong>{scene.username}</strong>
                  </div>
                  </Carousel.Item>
                )
              })
              }
    </Carousel>
   
   Share
  <TelegramShareButton url={window.location.href}>
  <TelegramIcon size={32} round={true}/>
  </TelegramShareButton>
  <RedditShareButton url={window.location.href}>
  <RedditIcon size={32} round={true}/>
    </RedditShareButton>
   

    </Col>
       </Row>
       </Container>
    )
}